import { Configuration } from './types';

export const config: Pick<Configuration, 'portalApi' | 'mapbox' | 'remoteHazardAssets' | 'sentry' | 'environment' | 'gaTagId'> = {
  portalApi: 'https://mbready-api.manitoba.ca/v1',
  mapbox: {
    token: 'pk.eyJ1IjoiZ2VudmlzLW1hbml0b2JhIiwiYSI6ImNtYmVpY3E4ZjB4azcyaXNiejhyZWR5OXYifQ.zGTYh8yuHwkFySrJHnMcFg',
  },
  remoteHazardAssets: {
    iconAssetsPathSvg: 'https://genvis.com/assets/icons/map/pins',
    iconAssetsPathPng: 'https://genvis.com/assets/icons/map/pins/40x40',
  },
  sentry: {
    // TODO: This is the EWA Sentry DSN, not the ECA one - https://genvis.atlassian.net/browse/KUDO1-6533
    dsn: 'https://49bc98a2766fe6c2d605f8353b010a2b@o4507253793816576.ingest.de.sentry.io/4507255077339216',
  },
  gaTagId: 'G-3K1XHEWMMS',
  environment: 'prd',
};
